import { dayjs } from '@shared/utils';

export function getBlockedRecordByActiveType<
  T extends {
    blockedAt: Date;
    blockedUntil: Date | null;
  },
>(blockedRecords: T[]) {
  const today = dayjs();

  const [pendingRecords, activeRecords, inactiveRecords] = blockedRecords.reduce(
    (acc, record) => {
      const startDate = dayjs(record.blockedAt);
      const endDate = record.blockedUntil ? dayjs(record.blockedUntil).endOf('day') : null;

      // Pending: startDate is in the future
      if (startDate.isAfter(today)) {
        acc[0].push(record);
        return acc;
      }

      // Active: startDate is today or in the past, and (endDate is null or endDate is today or in the future)
      if (!endDate || endDate.isSameOrAfter(today)) {
        acc[1].push(record);
        return acc;
      }

      // Inactive: endDate is in the past
      acc[2].push(record);
      return acc;
    },
    [[], [], []] as [T[], T[], T[]],
  );

  return {
    pendingRecords,
    activeRecords,
    inactiveRecords,
  };
}
